<template>
  <div :class="{ 'service-transition': true, 'is-small': size === 'small' }">
    <button
      :title="$t('플랫폼 전환')"
      type="button"
      class="action-button officehome-gnb-hr"
      :class="{ 'icon-button__selected': isVisible }"
      @click="onShow"
    >
      <SquaresIcon :size="size" />
    </button>
    <div
      v-show="isVisible"
      ref="dropdown-list"
      class="dropdown-wrapper"
      :class="{
        'service-platform': size === 'small',
      }"
      tabindex="0"
      @focusout="onCloseDropdownMenu"
    >
      <h3 v-if="platformInfoList.length">
        {{ $t('다음으로 전환') }}
      </h3>
      <div class="service-wrapper" v-if="platformInfoList.length">
        <template v-for="menu in platformInfoList">
          <button
            class="service-btn officehome-gnb-hr"
            :key="menu.menu_type"
            @click="(e) => handleMove(menu)"
            :class="{
              'service-btn-platform': size === 'small',
            }"
          >
            <div class="service-btn-left">
              <div class="service-btn-icon" v-html="menu.icon" />
              <h3>
                {{ menu.name }}
              </h3>
            </div>
            <div class="service-btn-right-wrapper">
              <!-- 베타 종료로 인한 메뉴얼 이동 제거 -->
              <!-- <button
                :title="$t('매뉴얼 이동')"
                v-if="menu.menu_type === 'SALES_LINK'"
                class="service-btn-right"
                @click.stop="handleOpenNewTab('https://www.hiworks.com/manual/hiworks/22261/22320')"
              >
                <span class="svg-wrapper">
                  <OpenNewFeedback />
                </span>
              </button> -->
              <button
                class="service-btn-right"
                @click.stop="(e) => handleMove(menu, true)"
                :title="$t('새창으로 열기')"
              >
                <div class="svg-wrapper">
                  <OpenNewFenetre />
                </div>
              </button>
            </div>
          </button>
        </template>
      </div>
      <template v-if="bannerList.length">
        <div class="divider" v-if="platformInfoList.length" />
        <div class="banner-margin-top" v-if="!platformInfoList.length" />
        <div class="available-service-wrapper">
          <p>사용할 수 있는 플랫폼</p>
          <div class="service-wrapper">
            <template v-for="banner in bannerList">
              <button
                class="service-btn banner-btn"
                :key="banner.title"
                @click="(e) => handleBannerClick(banner.link, false)"
              >
                <div class="service-btn-left">
                  <div v-html="banner.icon" />
                  <div class="service-btn-left-title">
                    <h3>
                      {{ banner.title }}
                    </h3>
                    <p>{{ banner.content }}</p>
                  </div>
                </div>
                <span class="service-btn-right-wrapper">
                  <button
                    class="service-btn-right"
                    @click.stop="(e) => handleBannerClick(banner.link, true)"
                    :title="$t('새창으로 열기')"
                  >
                    <div class="svg-wrapper">
                      <OpenNewFenetre />
                    </div>
                  </button>
                </span>
              </button>
            </template>
            <!--            <button class="service-btn officehome-gnb-hr" @click="(e) => handleMove(salesMenu.at(0))">-->
            <!--              <div class="service-btn-left">-->
            <!--                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">-->
            <!--                  <path style="fill:transparent" d="M0 0h22v22H0z" />-->
            <!--                  <path d="M4 23.991v8.388h5.392V18z" transform="translate(-2.702 -11.821)" style="fill:#f8ac03" />-->
            <!--                  <path-->
            <!--                    d="M43.888 4 35.5 12.388v10.784h8.388z"-->
            <!--                    transform="translate(-23.418 -2.614)"-->
            <!--                    style="fill:#d96b0d"-->
            <!--                  />-->
            <!--                  <path d="M19.75 18v14.379h5.392V21.595z" transform="translate(-13.06 -11.821)" style="fill:#e68115" />-->
            <!--                </svg>-->
            <!--                <div class="title">-->
            <!--                  <div>세일즈(β)</div>-->
            <!--                  <p>효율적인 영업관리</p>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--              <button-->
            <!--                class="service-btn-right"-->
            <!--                @click.stop="(e) => handleMove(salesMenu.at(0), true)"-->
            <!--                :title="$t('새창으로 열기')"-->
            <!--              >-->
            <!--                <div class="svg-wrapper">-->
            <!--                  <OpenNewFenetre />-->
            <!--                </div>-->
            <!--              </button>-->
            <!--            </button>-->
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import OpenNewFenetre from './Icon/management-service/OpenNewFenetre.vue';
import SquaresIcon from './Icon/management-service/SquaresIcon.vue';

export default {
  name: 'ServiceTransition',
  components: {
    SquaresIcon,
    OpenNewFenetre,
    // OpenNewFeedback,
  },
  props: {
    size: {
      type: String,
      required: false,
      default: 'default',
    },
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      isPlatformBannerValid: 'banner/isPlatformBannerValid',
    }),
    ...mapState({
      platformInfoList: (state) =>
        state.menu.platformMenuInfoList.map((menu) => ({
          ...menu,
          icon: menu.icon
            ? menu.icon
            : `<svg data-name="img_office(re)" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
    <defs>
        <clipPath id="z1eeq6uuoa">
            <path style="fill:none" d="M0 0h30v30H0z"/>
        </clipPath>
    </defs>
    <g style="clip-path:url(#z1eeq6uuoa)">
        <g >
            <g style="clip-path:url(#z1eeq6uuoa)">
                <path d="M22.5 16a6.5 6.5 0 0 1 1.051.093 11.021 11.021 0 1 0-7.458 7.458A6.458 6.458 0 0 1 22.5 16" style="fill:#1080dd"/>
                <path d="M29 22.5a6.5 6.5 0 0 0-5.449-6.407 11.008 11.008 0 0 1-7.458 7.458 6.485 6.485 0 0 0 9.877 4.439L29 29l-1.01-3.03A6.467 6.467 0 0 0 29 22.5" style="fill:#a8cdf0"/>
                <path d="M23.551 16.093a6.464 6.464 0 0 0-7.459 7.459 11.014 11.014 0 0 0 7.459-7.459" style="fill:#054ca8"/>
                <path d="M19.624 9.584a.75.75 0 0 0-1.04-.208L13 13.1 7.416 9.376a.75.75 0 1 0-.832 1.248l2.839 1.893L7 14.939A.75.75 0 1 0 8.061 16l2.634-2.635 1.889 1.259a.75.75 0 0 0 .832 0l1.884-1.259L17.939 16A.75.75 0 0 0 19 14.939l-2.423-2.422 2.839-1.893a.749.749 0 0 0 .208-1.04" style="fill:#fff"/>
            </g>
        </g>
    </g>
</svg>
`,
        })),
    }),
  },
  data() {
    return {
      isUseSales: process.env.VUE_APP_USE_SALES === 'Y',
      bannerList: [],
    };
  },

  methods: {
    /** 세일즈 서비스 종료 대응을 위한 서비스알럿 */
    handleSalesServiceAlert() {
      window.alert('세일즈 베타 테스트가 종료되었습니다.\n6월 중순에 베타 서비스로 다시 찾아 뵙겠습니다.');
    },

    /** 기존 handleMove가 비즈니스 로직을 많이 가지고있어, handleBannerClick으로 대체 */

    handleOpenNewTab(url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    },
    handleBannerClick(link, isBlank = false) {
      if (isBlank) {
        window.open(link);
      } else {
        location.href = link;
      }
    },

    async onShow() {
      this.$emit('set-is-visible', !this.isVisible);
      !this.isVisible && this.$nextTick(() => this.$refs['dropdown-list'].focus());

      if (!this.isPlatformBannerValid) {
        this.bannerList = await this.$store.dispatch('banner/fetchPlatformBanner');
      }
    },
    onCloseDropdownMenu(e) {
      const isMenuButton = !!e.relatedTarget?.closest('div.service-transition');
      if (!isMenuButton) this.$emit('set-is-visible', false);
    },
    handleMove(menu, isBlank = false) {
      /** todo: 세일즈 서비스 종료 대응을 위한 코드 */
      // if (menu.menu_type === 'SALES_LINK') {
      //   this.handleSalesServiceAlert();
      //   return;
      // }

      const link = menu.is_include_domain ? `${menu.sub_domain}/${menu.domain}${menu.url}` : `${menu.sub_domain}`;

      if (menu.target !== '_self' || isBlank) {
        window.open(link);
        return;
      }

      if (menu.target === '_self') {
        location.href = link;
        return;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/mixins/icon.scss';
@import '@/assets/scss/base/variables.scss';

.service-transition {
  text-align: left;
  position: relative;
}

.action-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 4px;

  &:hover {
    background-color: rgba(159, 166, 173, 0.2);
  }
}

.service-transition {
  .dropdown-wrapper {
    position: fixed;
    width: 100%;
    top: $headerHeight;
    right: 0px;
    background: #fff;
    border: solid 1px #909090;
    border-radius: 4px;
    box-shadow: 2px 5px 4px 0 rgba(0, 0, 0, 0.16);
    max-height: calc(100vh - 70px);

    @media (min-width: 900px) {
      position: absolute;
      width: 285px;
      top: 48px;
      right: -10px;
    }

    h3 {
      color: #333;
      font-size: 16px;
      margin-top: 16px;
      padding: 0 16px;
    }

    .service-wrapper {
      display: flex;
      flex-direction: column;
      margin: 16px 0;

      .service-btn {
        display: flex;
        align-items: center;
        gap: 0;
        justify-content: space-between;
        height: 42px;

        &:hover .service-btn-right {
          display: block !important;
        }

        .service-btn-left {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 10px 0 10px 16px;

          h3 {
            font-size: 14px;
            font-weight: normal;
            margin-top: 0;
            padding: 0;
          }

          .service-btn-icon {
            display: flex;
            align-items: center;
          }
        }

        .service-btn-right-wrapper {
          display: flex;
          gap: 4px;
          padding-right: 16px;
        }

        .service-btn-right {
          display: none;
          .svg-wrapper {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 26px;
            height: 26px;
            border-radius: 4px;
          }
          svg {
            fill: #909090;
            width: 16px;
            height: 16px;
            pointer-events: none;
          }
          &:hover {
            .svg-wrapper {
              background-color: rgba(190, 198, 204, 0.2);
            }
          }
        }

        &:hover {
          background-color: #f9fafb;
        }
      }
    }

    &.service-platform {
      h3 {
        font-size: 13px;
        font-weight: bold;
      }

      .service-wrapper {
        .service-btn {
          &:hover {
            background-color: #f0f3f6;
          }
        }
      }
    }

    .divider {
      width: calc(100% - 32px);
      height: 1px;
      background: #eaeaea;
      margin: 16px;
    }

    .banner-margin-top {
      margin-top: 16px !important;
    }

    .available-service-wrapper {
      margin-bottom: 16px;

      > p {
        padding: 0 16px;
        font-size: 12px;
        color: #909090;
        margin-bottom: 8px;
      }

      .service-wrapper {
        //height: 60px;

        .service-btn {
          height: 100%;
        }
      }

      .service-btn-left-title {
        display: flex;
        flex-direction: column;

        h3 {
          align-self: flex-start;
          padding: 0;
        }
        p {
          font-size: 12px;
          color: #909090;
          margin-bottom: 8px;
          word-break: keep-all;
          align-self: flex-start;
          text-align: start;
        }
      }
    }
  }
}

.service-btn {
  cursor: pointer;
}

.service-transition.is-small {
  .dropdown-wrapper {
    position: absolute;
    width: 285px;
    top: 43px !important;
    right: -10px;

    @media (min-width: 900px) {
      position: absolute;
      width: 285px;
      top: 43px;
      right: -10px;
    }
  }

  .action-button {
    width: 34px;
    height: 34px;
  }
}
</style>
